export function setDocumentStyles(styles: Partial<CSSStyleDeclaration>): void {
  const documentStyle = document.documentElement.style
  for (const key in styles) {
    if (documentStyle[key] !== styles[key]) {
      documentStyle[key] = styles[key]
    }
  }
}
